/*jshint esversion: 6 */

import { 
    faCircle, 
    faCircleQuestion, 
    faCircleUser,
    faCircleXmark, 
    faClock, 
    faEnvelope, 
    faEye as fayEyeReg,
    faPaperPlane, 
    faSquare, 
    faSquareCheck, 
    faTrashCan,  
} from '@fortawesome/free-regular-svg-icons';
import { 
    faArrowDown, 
    faArrowRight, 
    faArrowRightFromBracket,
    faArrowUpFromBracket,
    faAt, 
    faCheck,
    faChevronDown, 
    faChevronUp, 
    faCircleExclamation, 
    faEnvelope as faEnvelopeSolid,
    faExclamation, 
    faEye, 
    faEyeSlash, 
    faFileImport,
    faInfo, 
    faLock,
    faMagnifyingGlass,
    faMagnifyingGlassMinus, 
    faMagnifyingGlassPlus, 
    faPencil, 
    faPhone,
    faPrint, 
    faRightLong, 
    faSort, 
    faSortDown, 
    faSortUp, 
    faXmark,
} from '@fortawesome/free-solid-svg-icons';

export function getFawLibrary() {
    const library = [
        faArrowDown,
        faArrowRight,
        faArrowRightFromBracket,  
        faArrowUpFromBracket,
        faAt, 
        faCheck,
        faChevronDown, 
        faChevronUp, 
        faCircle, 
        faCircleExclamation,
        faCircleQuestion, 
        faCircleUser, 
        faCircleXmark, 
        faClock,  
        faEnvelope, 
        faEnvelopeSolid,
        faExclamation, 
        faEye, 
        faEyeSlash, 
        faFileImport, 
        faInfo,
        faLock,
        faMagnifyingGlass,
        faMagnifyingGlassMinus, 
        faMagnifyingGlassPlus, 
        faPaperPlane, 
        faPencil, 
        faPhone,
        faPrint, 
        faRightLong, 
        faSort, 
        faSortDown, 
        faSortUp, 
        faSquare, 
        faSquareCheck,
        faTrashCan,  
        faXmark,
        fayEyeReg,
    ];

    return library;
}

